'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React from 'react';
import {CommentIndicatorComponent} from '../../../comments/components/CommentIndicator/CommentIndicatorComponent';
import {ListItem} from '../../../components/lists/ListItem';
import {StatelessStatusSelector} from '../../../core-components/selectors/components/StatelessStatusSelector';
import {getAsString, getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {stopPropagation} from '../../../core-utilities/react-utils';


export function FormRequirementItemView(props) {
  const model = props.model;

  const name = getAsString(model);
  const description = model.description;

  return (
    <ListItem
      className={classNames(
        "RequirementItem",
        props.className,
      )}
      bindParam={model}
      onClick={props.onClick}
      onContextMenu={props.onContextMenu}
    >
      <div className="RequirementItem__content">
        <div className="RequirementItem__slideItem">
          <div className={classNames(
            "RequirementItem__innerContent", {
              'double-line': description,
            },
          )}
          >
            <div
              className="RequirementItem__left"
              onClick={stopPropagation}
            >
              <StatelessStatusSelector
                className="RequirementItem__status"
                labelClassName=""
                model={props.model}

                hideValue={true}

                status={props.model.status}
                collection={props.model.collection}
                validStatuses={props.model.validStatuses}
              />
            </div>

            <h2 className={classNames({
              RequirementItem__title_single: !description,
            })}
            >
              {name}
            </h2>
            <span
              className="item-description"
              title={description}
            >
              {description || ' '}
            </span>

            <div className="RequirementItem__right">
              <div className="RequirementItem__metrics">
                <i className="icon ion-ios-list-outline" />
                <span
                  className="RequirementItem__metrics__label"
                  title={props.fileCountTitle}
                >
                  {get(model.metrics, 'formFieldComplete', '-')}
                  {' / '}
                  {get(model.metrics, 'formFieldTotal', '-')}
                </span>
              </div>

              <CommentIndicatorComponent
                className="RequirementItem__chat"
                userId={props.userId}
                chatId={getId(props.model)}
                collection={getCollection(props.model)}
                allowNav={false}
                init={props.init}
              />
            </div>
          </div>
        </div>
      </div>
    </ListItem>
  );
}

FormRequirementItemView.propTypes = {
  className: T.string,
};

FormRequirementItemView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/requirements/components/FormRequirementItem/FormRequirementItemView.js